import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomModalComponent } from './custom-modal.component';
import { CustomModalRootingModule } from './custom-modal-routing.module';
import { CustomRequestQuoteModule } from '../custom-request-quote/custom-request-quote.module';

@NgModule({
  declarations: [CustomModalComponent],
  imports: [CommonModule, CustomModalRootingModule, CustomRequestQuoteModule],
  exports: [CustomModalComponent],
})
export class CustomModalModule {}
